import React from "react";

const QuestionIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 22V22.75C13.4142 22.75 13.75 22.4142 13.75 22H13ZM2 22H1.25C1.25 22.4142 1.58579 22.75 2 22.75V22ZM13 21.25H2V22.75H13V21.25ZM2.75 22C2.75 19.7185 4.80777 17.75 7.5 17.75V16.25C4.11708 16.25 1.25 18.7587 1.25 22H2.75ZM7.5 17.75C10.1922 17.75 12.25 19.7185 12.25 22H13.75C13.75 18.7587 10.8829 16.25 7.5 16.25V17.75ZM9.25 12C9.25 12.9665 8.4665 13.75 7.5 13.75V15.25C9.29493 15.25 10.75 13.7949 10.75 12H9.25ZM7.5 13.75C6.5335 13.75 5.75 12.9665 5.75 12H4.25C4.25 13.7949 5.70507 15.25 7.5 15.25V13.75ZM5.75 12C5.75 11.0335 6.5335 10.25 7.5 10.25V8.75C5.70507 8.75 4.25 10.2051 4.25 12H5.75ZM7.5 10.25C8.4665 10.25 9.25 11.0335 9.25 12H10.75C10.75 10.2051 9.29493 8.75 7.5 8.75V10.25Z"
      fill="currentColor"
    />
    <path
      d="M22 6.78335C22 9.4249 19.761 11.5667 17 11.5667C16.6753 11.5671 16.3516 11.5371 16.0327 11.4772C15.8031 11.434 15.6884 11.4126 15.6083 11.4248C15.528 11.4369 15.4145 11.4973 15.1875 11.6182C14.5451 11.9598 13.796 12.0805 13.0756 11.9465C13.3493 11.6096 13.5364 11.2056 13.6188 10.7723C13.6689 10.5074 13.545 10.25 13.3593 10.0616C12.5167 9.20575 12 8.05253 12 6.78335C12 4.14178 14.2389 2 17 2C19.761 2 22 4.14178 22 6.78335Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5 7H15.5081M18.4919 7H18.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default QuestionIcon;
